import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';

import { TabsConfig } from '../../components/tabs/useTabs';
import { Routes } from '../../routes/routes';
import { useAdminValidation } from '../../hooks/useAdminValidation';

import { DEFAULT_TAB, ReportsTabs } from './model';
import { View } from './view';
import { initializeTab } from './services';

export const Reports = () => {
    const navigate = useNavigate();
    const { tab: initialTab } = useParams<{ tab: ReportsTabs }>();
    const tabsConfig: TabsConfig = useMemo(
        () => ({
            onTabChanged: (tabIndex) => {
                navigate(`${Routes.reports}/${tabIndex}`);
            },
        }),
        [navigate],
    );

    const isAdmin = useAdminValidation();
    useEffect(() => {
        if (isAdmin) {
            const tab = initializeTab(initialTab);
            navigate(`${Routes.reports}/${tab}`);
        }
    }, [initialTab, navigate, isAdmin]);

    return View({
        tabsConfig,
        initialTab: initialTab ?? DEFAULT_TAB,
    });
};
